import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=4453d6a6&scoped=true"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453d6a6",
  null
  
)

export default component.exports